import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import PaymentMethodForm from '../components/PaymentMethodForm/PaymentMethodForm';
import ECheckPaymentMethodForm from '../components/PaymentMethodForm/ECheckPaymentMethodForm';
import {
  createPaymentMethod,
  createECheckPaymentMethod,
} from '../actions/payments';
import {
  getPaymentMethodSucceeded,
  getEcheckPaymentMethodSucceeded,
} from '../reducers';

const CARD_FORM = 'CARD_FORM';
const ECHECK_FORM = 'ECHECK_FORM';
class CreatePaymentMethod extends React.Component {
  state = {
    formType: CARD_FORM,
  };

  toggleFormType = () => {
    this.setState({
      formType: this.state.formType === CARD_FORM ? ECHECK_FORM : CARD_FORM,
    });
  };

  handleCreatePaymentMethod = async (values) => {
    const { user, createPaymentMethod, createECheckPaymentMethod } = this.props;

    if (this.state.formType === ECHECK_FORM) {
      return await createECheckPaymentMethod(user.id, values);
    } else {
      return await createPaymentMethod(user.id, values);
    }
  };

  render() {
    const { formType } = this.state;
    const { user, submitSucceeded, onSuccess } = this.props;

    if (submitSucceeded) {
      onSuccess();
      return <Redirect to={`/users/${user.id}/payment-methods`} />;
    }

    const isECheck = formType === ECHECK_FORM;
    const isBusinessUser = user?.acl_group_name === 'BUSINESS';
    const initialValues = { is_default: false };

    return (
      <div>
        <div className="d-flex-vc mar-t mar-b">
          <h2 className="mar-0">Add a {isECheck && 'ECheck'} Payment Method</h2>
          {isBusinessUser && (
            <button
              type="button"
              className="btn btn-default mar-l"
              onClick={this.toggleFormType}
            >
              {isECheck ? 'Add Card' : 'Add ECheck'}
            </button>
          )}
        </div>
        {isECheck ? (
          <ECheckPaymentMethodForm
            initialValues={initialValues}
            onSubmit={this.handleCreatePaymentMethod}
          />
        ) : (
          <PaymentMethodForm
            initialValues={initialValues}
            onSubmit={this.handleCreatePaymentMethod}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  submitSucceeded:
    getPaymentMethodSucceeded(state) || getEcheckPaymentMethodSucceeded(state),
});

const mapDispatchToProps = {
  createPaymentMethod,
  createECheckPaymentMethod,
};

CreatePaymentMethod = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreatePaymentMethod);

export default CreatePaymentMethod;
